module.exports = __webpack_public_path__ + "static/media/41-2.6364e778.mp3";